import { PhaseType } from './AppConstants'

/**
 * Method to get failure warranty
 */
export function GetFaultWarranty() {
	let types = []
	types.push({ value: 1, label: 'Capillary tube' })
	types.push({ value: 2, label: 'Clogged System' })
	types.push({ value: 3, label: 'Compressor Components' })
	types.push({ value: 4, label: 'Compressor Replacement' })
	types.push({ value: 5, label: 'Condenser' })
	types.push({ value: 6, label: 'Components' })
	types.push({ value: 7, label: 'Cooler replacement' })
	types.push({ value: 8, label: 'Door adjustment' })
	types.push({ value: 9, label: 'Drain' })
	types.push({ value: 10, label: 'Evaporator' })
	types.push({ value: 11, label: 'False contacts - Electrical' })
	types.push({ value: 12, label: 'Freight' })
	types.push({ value: 13, label: 'Gas leak' })
	types.push({ value: 14, label: 'Heater VFS24' })
	types.push({ value: 15, label: 'KIT CO2 (NO LABOR)' })
	types.push({ value: 16, label: 'KIT CO2 Canada' })
	types.push({ value: 17, label: 'LED (light  /driver)' })
	types.push({ value: 18, label: 'Low charge' })
	types.push({ value: 19, label: 'Motors - Electrical' })
	types.push({ value: 20, label: 'No Failure' })
	types.push({ value: 21, label: 'Noise' })
	types.push({ value: 22, label: 'Switch - Electrical' })
	types.push({ value: 23, label: 'Temp control - Electrical' })
	return types
}

/**
 * Method to get service type
 */
export function GetServiceType() {
	let types = []
	types.push({ value: 1, label: 'FOR COCA COLA (CC)' })
	types.push({ value: 2, label: 'MICRO MARKET (MM)' })
	return types
}
export function GetParcelName() {
	let types = []
	types.push({ value: 1, label: 'FEDEX' })
	types.push({ value: 2, label: 'UPS' })
	types.push({ value: 3, label: 'SAP' })
	return types
}

export function GetWarehouse() {
	let types = []
	types.push({ value: 0, label: 'No Selected' })
	types.push({ value: 1, label: 'Mexico' })
	types.push({ value: 2, label: 'USA' })
	return types
}

/**
 * Method to get all carriers selected
 */
export function GetCarriers() {
	let types = []
	types.push({ oldvalue: ' ', value: ' ', label: ' ' })
	types.push({ oldvalue: 'FedEx', value: 'FedEx', label: 'FedEx' })
	types.push({ oldvalue: 'UPS', value: 'UPS', label: 'UPS' })
	types.push({ oldvalue: 'DHL', value: 'DHL', label: 'DHL' })
	types.push({ oldvalue: 'Estes', value: 'Estes', label: 'Estes' })
	types.push({ oldvalue: 'RL-Carriers', value: 'RL-Carriers', label: 'RL-Carriers' })
	types.push({ oldvalue: 'Saia-Freight', value: 'Saia-Freight', label: 'Saia-Freight' })
	types.push({ oldvalue: 'aaacooper', value: 'Aaacooper', label: 'Aaacooper' })
	types.push({ oldvalue: 'ABF freight', value: 'ABF', label: 'ABF Freight' })
	types.push({ oldvalue: 'Averitt Express', value: 'AverittExpress', label: 'Averitt Express' })
	types.push({ oldvalue: 'Estes Express', value: 'EstesExpress', label: 'Estes Express' })
	types.push({ oldvalue: 'Old Dominion Freight', value: 'OldDominion', label: 'Old Dominion Freight' })
	types.push({ oldvalue: 'R&L Carriers IncSAIA', value: 'RL-Carriers', label: 'R&L Carriers IncSAIA' })
	types.push({ oldvalue: 'Southeastern freight lines', value: 'SE-FreightLines', label: 'Southeastern Freight Lines' })
	types.push({ oldvalue: 'XPOweb', value: 'XPOweb', label: 'XPO Logistics (XPO web)' })
	types.push({ oldvalue: 'Daylight Transport', value: 'DYLT', label: 'Daylight Transport' })
	types.push({ oldvalue: 'Roadrunner Freight', value: 'RRTS', label: 'Roadrunner Freight' })
	types.push({ oldvalue: 'USPS', value: 'USPS', label: 'USPS' })
	types.push({ oldvalue: 'Other', value: 'Other', label: 'Other' })
	return types
}
/**
 * Method to gett status traking selected
 */
export function GetStatusTracking() {
	let types = []
	types.push({ value: '', label: 'No status' })
	types.push({ value: 'Transit', label: 'Transit' })
	types.push({ value: 'Delivered', label: 'Delivered' })
	types.push({ value: 'Cancelled', label: 'Cancelled' })
	return types
}

/**
 * Method to get documents type to requeres add supplier
 */
export function GetDocumentType() {
	let types = []
	types.push({ value: 4, label: 'W8' })
	types.push({ value: 1, label: 'W9' })
	types.push({ value: 2, label: 'Proof of Insurance' })
	types.push({ value: 5, label: 'Others' })
	return types
}

/**
 * Method to get warranty type
 */
export function GetWarrantyType() {
	let types = []
	types.push({ value: 1, label: 'Warranty' })
	types.push({ value: 2, label: 'Sale' })
	return types
}

/**
 * Method to get all GetSparePartSaleStatus selected
 */
export function GetSparePartSaleStatus() {
	let types = []
	// types.push({ value: 0, label: ' ', icon: null })
	types.push({ value: 1, label: 'Activo' })
	types.push({ value: 2, label: 'Cancelado' })
	return types
}

export function GetPhaseOptionsTypes() {
	const dispatchPhaseOptions = [
		{ value: PhaseType.BACK_ORDER, label: 'Back-Order' },
		{ value: PhaseType.BACK_ORDER_PARTIAL, label: 'Back-Order-Partial' },
		{ value: PhaseType.CANCELLED, label: 'Cancelled' },
		{ value: PhaseType.CLOSED, label: 'Closed' },
		{ value: PhaseType.COMPLETED, label: 'Completed' },
		{ value: PhaseType.DIAGNOSTIC_REPORT, label: 'Diagnostic Report' },
		{ value: PhaseType.DIAGNOSTIC_SERVICE_SCHEDULED, label: 'Diagnostic-Service Scheduled' },
		{ value: PhaseType.DIAGNOSTIC_WAITING_TO_BE_SCHEDULED, label: 'Diagnostic-Waiting To Be Scheduled' },
		{ value: PhaseType.FOLLOW_UP, label: 'Follow-Up' },
		{ value: PhaseType.INSTALL_PARTS_SCHEDULED, label: 'Install-Parts-Scheduled' },
		{ value: PhaseType.INSTALL_PARTS_SCHEDULING, label: 'Install-Parts-Scheduling' },
		{ value: PhaseType.NEW_SERVICE_TICKET, label: 'New Service Ticket' },
		{ value: PhaseType.ON_HOLD, label: 'On Hold' },
		{ value: PhaseType.PARTS_PENDING_DELIVERY, label: 'Parts-Pending Delivery' },
		{ value: PhaseType.REPLACEMENT, label: 'Replacement' },
		{ value: PhaseType.SERVICE_QUOTE, label: 'Service Quote' },
		{ value: PhaseType.SERVICED, label: 'Serviced' },
		{ value: PhaseType.WAITING_FOR_CUSTOMER, label: 'Waiting for Customer' },
		{ value: PhaseType.WAITING_FOR_SALES_REP, label: 'Waiting for Sales Rep' },
		{ value: PhaseType.WAITING_FOR_SERVICE_PROVIDER, label: 'Waiting for Service Provider' },
		{ value: PhaseType.WAITING_ON_PARTS, label: 'Waiting on Parts' }
	]
	return dispatchPhaseOptions
}

export function GetAccountType() {
	let types = []
	types.push({ value: 0, label: 'Undefined' })
	types.push({ value: 1, label: 'Registered User' })
	types.push({ value: 2, label: 'Non Registered User' })
	return types
}

export function GetImberaTechnician() {
	return [
		{ name: 'US Customer', email: 'uscustomer.service@imberacooling.com' },
		{ name: 'Terry Hill', email: 'terry.hill@imberacooling.com' },
		{ name: 'Everardo Espinoza', email: 'everardo.espinoza@imberacooling.com' },
		{ name: 'Abimelec Acevedo', email: 'abimelec.acevedo@imberacooling.com' },
		{ name: 'Santiago Ramirez', email: 'santiago.ramirez@imberacooling.com' },
		{ name: 'Josue Sanchez', email: 'josue.sanchez@imberacooling.com' }
	]
}

/**
 * Generic helper to build select options from Immutable.js options
 * @param {Immutable.Map} optionsImmutable
 * @param {function} labelTransform - optional, receives (code, description, idx)
 * @returns {Array<{label: string, value: string}>}
 */
export function buildSelectOptions(optionsImmutable, labelTransform) {
	if (!optionsImmutable) return []
	const codes = optionsImmutable.get('Codes')?.toJS() ?? []
	const descriptions = optionsImmutable.get('Descriptions')?.toJS() ?? []
	return codes.map((code, idx) => ({
		label: labelTransform ? labelTransform(code, descriptions[idx], idx) : descriptions[idx] || code,
		value: code
	}))
}
